import * as Config from '../../../../config';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";

import Content from '../../common/Content';
import GridCharts from '../../content/grid/GridCharts';
import ListV2 from '../../content/list/ListV2';
import SubMenu from '../../common/SubMenu';
import TrendsV2 from '../../trends/TrendsV2';
import GridGenres from '../../content/grid/GridGenres';

function ConnectedDJedits({ id, name, hasSideMenu = true, dimension }) {
  let { url } = useRouteMatch();
  const { width, height } = dimension;
  const cutName = (name.length > 25 && width < 1200) ? Config.limitString(name, 21) : name;

  const aTrends = useMemo(() => {
    let base = [{
      id: `artists-${id}`, type: 'artists', title: `Featured Artists`, props: [`artists`, `remixers`], format: `formattedArtist`, isRandom: true, isRanked: false,
      grid: {
        rowWidth: 142, //135
        rowHeight: 165, //145,
        rowPadding: 4,
        coverBorder: 4,
        gap: 8,
        hasPagination: true,
        blockClassName: 'card-artist',
        coverClassName: 'cover-artist'
      }
    }];
    return base;
  }, [id])

  const customCharts = (base, x, i) => {
    const categories = ['Club Killers', 'Direct Music Service', 'DJcity', 'DJ Edits'];
    const check = categories.find(name => x.name.toLowerCase().includes(name.toLowerCase()))
    if (check) {
      base.push(x);
    }
    return base;
  }

  return (
    <Content name={cutName} isSticky={true} 
      styleHeader={{width: hasSideMenu ? width - Config.SUB_SIDEBAR + (Config.CONTENT_PAD * 1.9) : width + (Config.CONTENT_PAD * 2)}}
      contentClassName={'hasStickyHeader'}
      titleClassName={''}
      subContent={
        <div className={'flexRow'}>
          <div className={`flexRow slider-menu genres-menu`}>
            <SubMenu to={`${url}/featured`} or={`${url}`} label={`Trending`} />
            <SubMenu to={`${url}/tracks`} label={`Tracks`} />
          </div>
        </div>
      }
    >
      <Switch>
        <Route exact path={[`${url}`, `${url}/featured`]}>
          <>
            <GridGenres title={`Playlists`} id={`featured_crates_djedits`}
              width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width } rowCount={1} height={Config.CARD_HEIGHT} rowHeight={Config.CARD_HEIGHT}
              hasPagination={true}
              pathApi={`/v4/catalog/charts/?enabled=true&is_published=true&per_page=100&genre_id=110`}
              className={`grid-chart djedits`} customReduceFormat={customCharts} showLoading={true} showTitle={true} />
            <TrendsV2
              pathApi={`/v4/catalog/tracks/?genre_id=110&per_page=100`}
              width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width}
              style={{marginBottom: 32}}
              params={aTrends}
            />
          </>
        </Route>
        <Route path={`${url}/charts`}>
          <GridCharts id={`${name}_charts`} 
            width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width} 
            perPage={100}
            height={ height - (Config.TAB_BAR_GUTTER * 4.3) }
            style={{ marginTop: -15 }} 
            hasFilters={true} 
            filtersStyle={{ top: 80, height: 250, marginTop: -7 }}
            buttonFilterStyle={{ top: 23 }}
            pathApi={`/v4/catalog/charts/?genre_id=${id}&enabled=true&is_published=true&per_page=100|45,958601` /* 2808395 */}
            className={`grid-chart genre-all`} 
            showLoading={true}
          />
        </Route>
        <Route path={`${url}/tracks`}>
          <ListV2
            pathApi={`/v4/catalog/tracks/?genre_id=${id}&per_page=100&preorder=false&order_by=-publish_date` /* /v4/catalog/genres/${id}/tracks/?per_page=100 */}
            sortable={false}
            id={`G-${id}-tracks`}
            width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width}
            height={height - Config.STICKY_HEADER_HEIGHT}
            size={Config.LIST_ROW_HEIGHT}
            style={{marginTop: -10}}
            isLoadMore={true}
            filtersStyle={{position: `absolute`, top: 23, right: 127}}
            panelStyle={{ margin: `0px 0px 16px 0px` }}
            type={`Full`}
            orderBy={[`title`, `label`, /*`genre_s`,*/ `release`]}
            filters={[`genre_track_name`, /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `publish_date`, `bpm`, `key_convert`, 'preorders']}
            automix={true}
            automixName={`${name} - Tracks`}
            automixStyle={{ position: `absolute`, top: 23, left: `auto`, right: 0 }}
            from={`${url}/tracks`}
          />
        </Route>
      </Switch>
    </Content>
  )
}

ConnectedDJedits.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
}

const DJedits = connect(
  state => ({
    dimension: state.dimension
   })
)(ConnectedDJedits);

export default DJedits;
